import { IconButton, InputAdornment, StandardTextFieldProps, TextField } from '@mui/material'
import { ReactNode } from 'react'

interface Props extends StandardTextFieldProps {
    errorText?: string
    className?: string
    iconButtons?: { icon: ReactNode; action?: () => void; loading?: boolean }[]
}
const CustomInput = ({ className, errorText, iconButtons = [], ...restOfProps }: Props) => {
    return (
        <TextField
            className={`${className}`}
            helperText={errorText}
            error={!!errorText}
            InputLabelProps={{
                sx: {
                    '&.Mui-focused': {
                        color: '#434a73',
                        fontWeight: 500,
                    },
                },
            }}
            InputProps={{
                endAdornment: iconButtons.length > 0 && (
                    <InputAdornment position="end">
                        {iconButtons.map((iconButton) => (
                            <IconButton
                                key={`button-${iconButton.icon?.toString()}`}
                                className="text-primary"
                                onClick={iconButton.action}
                                disabled={iconButton.loading ?? false}
                            >
                                {iconButton.icon}
                            </IconButton>
                        ))}
                    </InputAdornment>
                ),
            }}
            sx={{
                '& .MuiOutlinedInput-root': {
                    '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#434a73',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#434a73',
                        color: 'red',
                    },
                },
                '&:hover label': {
                    color: '#434a73',
                },
            }}
            {...restOfProps}
        />
    )
}

export default CustomInput
